import React from 'react'
import i18next from 'i18next'
import { getCookie } from '../../utils/cookies'
import { isUrlExternal, Link } from '../../utils/link'
import { slugify } from '../../utils/utils'
import { Links } from './footerState'
import { DataLayer } from '../../utils/datalayer'
import { PreFooterLayout } from './preFooterLayout'
import { DecorativeIcon } from '../../utils/spaarneIcons'

export const FooterLayout = (props: { items: Links; showCookiebar: () => void }) => (
  <footer id="a11y-footer" className="footer">
    <PreFooterLayout/>
    {i18next.language == 'nl' && (
      <div className="footer__top">
        <div className="footer__top-inner container--m gutter--m">
          <nav className="nav nav--quicklinks" aria-label={i18next.t('a11y:navLabelQuicklinks')}>
            <ul className="footer__cols">
              {/* Quicklinks */}
              <li className="footer__col footer__col--nav" key="column-1">
                <ul className="nav__list">
                  {props.items.map(
                    (item, index) =>
                      item.column == 'Column 1' && (
                        <li className={`nav__item ${isUrlExternal(item.url) ? 'link--external' : ''}`} key={`footer-link-${index}-${item.title}`}>
                          <DecorativeIcon iconId="icon--chevron-right-large" width="18px" height="18px" className="footer__icon" />
                          <Link url={item.url} className="nav__link" additionalOnClick={_ => DataLayer.footer(item.title)}>
                            {item.title}
                          </Link>
                          {isUrlExternal(item.url) && <DecorativeIcon iconId="icon--external" width="18px" height="18px" className="icon--external-link" /> }
                        </li>
                      )
                  )}
                </ul>
              </li>
              <li className="footer__col footer__col--nav" key="column-2">
                <ul className="nav__list">
                  {props.items.map(
                    (item, index) =>
                      item.column == 'Column 2' && (
                        <li className={`nav__item ${isUrlExternal(item.url) ? 'link--external' : ''}`} key={`footer-link-${index}-${item.title}`}>
                          <DecorativeIcon iconId="icon--chevron-right-large" width="18px" height="18px" className="footer__icon" />
                          <Link url={item.url} className="nav__link" additionalOnClick={_ => DataLayer.footer(item.title)}>
                            {item.title}
                          </Link>
                          {isUrlExternal(item.url) && <DecorativeIcon iconId="icon--external" width="18px" height="18px" className="icon--external-link" /> }
                        </li>
                      )
                  )}
                </ul>
              </li>
              <li className="footer__col footer__col--nav" key="column-3">
                <ul className="nav__list">
                  {props.items.map(
                    (item, index) =>
                      item.column == 'Column 3' && (
                        <li className={`nav__item ${isUrlExternal(item.url) ? 'link--external' : ''}`} key={`footer-link-${index}-${item.title}`}>
                          <DecorativeIcon iconId="icon--chevron-right-large" width="18px" height="18px" className="footer__icon" />
                          <Link url={item.url} className="nav__link" additionalOnClick={_ => DataLayer.footer(item.title)}>
                            {item.title}
                          </Link>
                          {isUrlExternal(item.url) && <DecorativeIcon iconId="icon--external" width="18px" height="18px" className="icon--external-link" /> }
                        </li>
                      )
                  )}
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    )}

    <div className="footer__bottom bg">
      <div className="footer__bottom-inner container--m gutter--m">
        {/* Legal */}
        <nav className="footer__legal nav--legal text--xs" aria-label={i18next.t('a11y:navLabelLegal')}>
          <ul className="nav__list">
            <li className="nav__item">
              {i18next.language == 'nl' ? (
                <Link url="/en" className="nav__link" lang="en">
                  {i18next.t('common:langENLong', { lng: 'en' })}
                </Link>
              ) : (
                <Link url="/" className="nav__link" lang="nl">
                  {i18next.t('common:langNLLong', { lng: 'nl' })}
                </Link>
              )}
            </li>
            {['Colofon', 'Disclaimer', 'Accessibility', 'CookieStatement'].map((label) => (
              <li className="nav__item" key={label}>
                <Link url={i18next.t(`footer:legal${label}Url`)} className="nav__link">
                  {i18next.t(`footer:legal${label}Text`)}
                </Link>
              </li>
            ))}
            <li className="nav__item">
              <button type="button" className="nav__link" onClick={props.showCookiebar}>
                {i18next.t('footer:legalCookieSettingsText')}
              </button>
            </li>
          </ul>
        </nav>
        

        {/* Socials */}
        <nav className="footer__socials nav--socials" aria-label={i18next.t('a11y:navLabelSocial')}>
          <ul className="nav__list">
            {[
              { platform: 'Facebook', icon: { width: 24, height: 24 } },
              { platform: 'LinkedIn', icon: { width: 24, height: 24 } },
              { platform: 'Instagram', icon: { width: 24, height: 24 } },
              { platform: 'YouTube', icon: { width: 24, height: 24 } },
            ].map((social) => (
              <li className="nav__item" key={social.platform}>
                <Link
                  className="button--icon icon--m"
                  url={i18next.t(`footer:social${social.platform}Url`)}
                  title={i18next.t('footer:socialFollowSpaarneOn', {
                    platform: social.platform,
                  })}
                >
                  <span className="sr-text">
                    {i18next.t('footer:socialFollowSpaarneOn', {
                      platform: social.platform,
                    })}
                  </span>
                  <DecorativeIcon iconId={`icon--${slugify(social.platform)}`} width={social.icon.width} height={social.icon.height} className="button__icon" />
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  </footer>
)
